 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"401":"401","500":"500","application-creating~channel-configuration~import~live-room~news-center~recipes-management~safety-ma~7da53384":"application-creating~channel-configuration~import~live-room~news-center~recipes-management~safety-ma~7da53384","application-creating":"application-creating","authorize":"authorize","buffer":"buffer","channel-configuration":"channel-configuration","discernLog~distribution~import~recipes-management~result-import~safety-management~school-affair~scho~931e6333":"discernLog~distribution~import~recipes-management~result-import~safety-management~school-affair~scho~931e6333","discernLog~distribution~import~recipes-management~school-affair~school-finance~school-information~sc~118ff262":"discernLog~distribution~import~recipes-management~school-affair~school-finance~school-information~sc~118ff262","import":"import","recipes-management":"recipes-management","school-affair":"school-affair","school-finance":"school-finance","school-information":"school-information","school-safety":"school-safety","safety-management":"safety-management","school-business":"school-business","live-room":"live-room","news-center":"news-center","school-configuration":"school-configuration","application-market":"application-market","entrance":"entrance","rules":"rules","consumption":"consumption","consumption-account~consumption-statistics":"consumption-account~consumption-statistics","consumption-account":"consumption-account","consumption-statistics":"consumption-statistics","discernLog":"discernLog","distribution":"distribution","result-import":"result-import","school-label-management":"school-label-management","dormitory-access-management":"dormitory-access-management","edit":"edit","health-management":"health-management","manage":"manage","monitor-management":"monitor-management","oem":"oem","record":"record","result-collect":"result-collect","result-detail":"result-detail","result-management":"result-management","school-manage":"school-manage","setting-management":"setting-management","visitor-system":"visitor-system","class":"class","consumption-merchant":"consumption-merchant","course":"course","detail":"detail","dorm":"dorm","home":"home","knowledge-payment":"knowledge-payment","login":"login","logout":"logout","parent":"parent","result-add-edit":"result-add-edit","school":"school","school-setup":"school-setup","settings":"settings","staff":"staff","student":"student","subject":"subject","subject-network":"subject-network","summary":"summary","usage":"usage"}[chunkId]||chunkId) + "." + {"401":"6b6d0824","500":"1bed8baa","application-creating~channel-configuration~import~live-room~news-center~recipes-management~safety-ma~7da53384":"0599e35e","application-creating":"af42240b","authorize":"7241c117","buffer":"b0661e8b","chunk-042b5b8c":"ee95352e","chunk-507810a7":"c40f9942","chunk-74ff9576":"b3237098","channel-configuration":"e5c03f8f","discernLog~distribution~import~recipes-management~result-import~safety-management~school-affair~scho~931e6333":"1af8bc01","discernLog~distribution~import~recipes-management~school-affair~school-finance~school-information~sc~118ff262":"df91fb6f","import":"431e5a7a","recipes-management":"5ec53c34","school-affair":"90a1c08d","school-finance":"051f69f3","school-information":"9a2e15d0","school-safety":"65e61653","safety-management":"4ceb725e","school-business":"49bdfd3b","live-room":"3dc622c3","news-center":"e8508582","school-configuration":"00bd6e4e","application-market":"cffeea1b","chunk-60bd3cca":"e6777c09","chunk-2220992f":"664b86d8","entrance":"ee784de9","rules":"fefa202b","consumption":"ab722b11","consumption-account~consumption-statistics":"7cab24ad","consumption-account":"a0f4ac79","consumption-statistics":"c03d44ca","discernLog":"7259e72e","distribution":"bed479b2","result-import":"864d6672","school-label-management":"e10a9146","dormitory-access-management":"5f51ca23","edit":"0acddc84","health-management":"34c5ee12","manage":"5c9e7bf7","monitor-management":"c1f0a5c6","oem":"41b9d556","record":"eaaa7305","result-collect":"2367aaef","result-detail":"068ced7b","result-management":"a60eb1d7","school-manage":"949c053d","setting-management":"592eeb6f","visitor-system":"4e0b38fc","chunk-bfeebac0":"d728ed12","class":"fc93baff","consumption-merchant":"c223491d","course":"0c76bad2","detail":"3c7d0601","dorm":"79b5d9ef","home":"052d96d9","knowledge-payment":"911f3c0f","login":"966af44b","logout":"b2284b59","parent":"f39d7cb4","result-add-edit":"844b43f5","school":"4b3e6fc8","school-setup":"9bcf49b8","settings":"a8b447a7","staff":"531f2272","student":"f3f1c7d0","subject":"df69bc47","subject-network":"c8025db4","summary":"b51ed88c","usage":"c574c21b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"401":1,"500":1,"application-creating":1,"buffer":1,"chunk-042b5b8c":1,"chunk-507810a7":1,"chunk-74ff9576":1,"channel-configuration":1,"import":1,"recipes-management":1,"school-affair":1,"school-finance":1,"school-information":1,"school-safety":1,"safety-management":1,"school-business":1,"live-room":1,"news-center":1,"school-configuration":1,"application-market":1,"chunk-60bd3cca":1,"chunk-2220992f":1,"entrance":1,"rules":1,"consumption":1,"consumption-account~consumption-statistics":1,"consumption-account":1,"consumption-statistics":1,"discernLog":1,"distribution":1,"result-import":1,"school-label-management":1,"dormitory-access-management":1,"edit":1,"health-management":1,"manage":1,"monitor-management":1,"oem":1,"record":1,"result-collect":1,"result-detail":1,"result-management":1,"school-manage":1,"setting-management":1,"visitor-system":1,"chunk-bfeebac0":1,"detail":1,"home":1,"login":1,"logout":1,"result-add-edit":1,"school-setup":1,"settings":1,"subject-network":1,"usage":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"401":"401","500":"500","application-creating~channel-configuration~import~live-room~news-center~recipes-management~safety-ma~7da53384":"application-creating~channel-configuration~import~live-room~news-center~recipes-management~safety-ma~7da53384","application-creating":"application-creating","authorize":"authorize","buffer":"buffer","channel-configuration":"channel-configuration","discernLog~distribution~import~recipes-management~result-import~safety-management~school-affair~scho~931e6333":"discernLog~distribution~import~recipes-management~result-import~safety-management~school-affair~scho~931e6333","discernLog~distribution~import~recipes-management~school-affair~school-finance~school-information~sc~118ff262":"discernLog~distribution~import~recipes-management~school-affair~school-finance~school-information~sc~118ff262","import":"import","recipes-management":"recipes-management","school-affair":"school-affair","school-finance":"school-finance","school-information":"school-information","school-safety":"school-safety","safety-management":"safety-management","school-business":"school-business","live-room":"live-room","news-center":"news-center","school-configuration":"school-configuration","application-market":"application-market","entrance":"entrance","rules":"rules","consumption":"consumption","consumption-account~consumption-statistics":"consumption-account~consumption-statistics","consumption-account":"consumption-account","consumption-statistics":"consumption-statistics","discernLog":"discernLog","distribution":"distribution","result-import":"result-import","school-label-management":"school-label-management","dormitory-access-management":"dormitory-access-management","edit":"edit","health-management":"health-management","manage":"manage","monitor-management":"monitor-management","oem":"oem","record":"record","result-collect":"result-collect","result-detail":"result-detail","result-management":"result-management","school-manage":"school-manage","setting-management":"setting-management","visitor-system":"visitor-system","class":"class","consumption-merchant":"consumption-merchant","course":"course","detail":"detail","dorm":"dorm","home":"home","knowledge-payment":"knowledge-payment","login":"login","logout":"logout","parent":"parent","result-add-edit":"result-add-edit","school":"school","school-setup":"school-setup","settings":"settings","staff":"staff","student":"student","subject":"subject","subject-network":"subject-network","summary":"summary","usage":"usage"}[chunkId]||chunkId) + "." + {"401":"aac51db4","500":"6588872c","application-creating~channel-configuration~import~live-room~news-center~recipes-management~safety-ma~7da53384":"31d6cfe0","application-creating":"016b2869","authorize":"31d6cfe0","buffer":"3a8c3542","chunk-042b5b8c":"66447a02","chunk-507810a7":"d604f7fa","chunk-74ff9576":"8682027a","channel-configuration":"277cc660","discernLog~distribution~import~recipes-management~result-import~safety-management~school-affair~scho~931e6333":"31d6cfe0","discernLog~distribution~import~recipes-management~school-affair~school-finance~school-information~sc~118ff262":"31d6cfe0","import":"59ac33d8","recipes-management":"95d9fea8","school-affair":"58d9fc12","school-finance":"e1861551","school-information":"4a31223a","school-safety":"ffebfc07","safety-management":"9319984c","school-business":"f1878b4e","live-room":"d42f0244","news-center":"e6bc4feb","school-configuration":"9f0ff254","application-market":"908ae744","chunk-60bd3cca":"fdf5a334","chunk-2220992f":"33ef2bef","entrance":"8fa8c3a6","rules":"bb4c1870","consumption":"41990d31","consumption-account~consumption-statistics":"396528ce","consumption-account":"0f4e4404","consumption-statistics":"308b65c0","discernLog":"143ff12e","distribution":"b4f79259","result-import":"66370f39","school-label-management":"1260e5e6","dormitory-access-management":"d9f7f620","edit":"d311eac1","health-management":"3fcacdde","manage":"8a6d48b6","monitor-management":"fafac882","oem":"094588b7","record":"c69c1973","result-collect":"574dafa5","result-detail":"fdb205b5","result-management":"8f052271","school-manage":"ef015c40","setting-management":"dea54e7f","visitor-system":"0dabbaa3","chunk-bfeebac0":"1673207a","class":"31d6cfe0","consumption-merchant":"31d6cfe0","course":"31d6cfe0","detail":"de6610ae","dorm":"31d6cfe0","home":"20a8643c","knowledge-payment":"31d6cfe0","login":"5f04785b","logout":"3a8c3542","parent":"31d6cfe0","result-add-edit":"f681811f","school":"31d6cfe0","school-setup":"3a8c3542","settings":"5acc4c03","staff":"31d6cfe0","student":"31d6cfe0","subject":"31d6cfe0","subject-network":"3a8c3542","summary":"31d6cfe0","usage":"99800c1e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/ControlPanel/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
